/*
  Fettle — serving calculator logging (anonymous)
  Watches every <serving-calculator> on the page and logs what people enter
  and what the calculator tells them to a Supabase table (GTG Nucleus →
  public.calculator_logs). No emails, no customer IDs, no cookies.

  Events:
    calculated     — results shown and inputs stopped changing for 2s
    added_to_cart  — the calculator's own "Add to cart" button was clicked
*/
(function () {
  'use strict';

  if (window.__fettleCalcLog) return;
  window.__fettleCalcLog = true;

  var ENDPOINT = 'https://sljuzxkhajqkxcgzfhex.supabase.co/rest/v1/calculator_logs';
  var KEY = 'sb_publishable_67e0iHSq85niQRevnmYmBQ_TA4Pn245';
  var DEBOUNCE_MS = 2000;
  var LB_TO_KG = 0.45359237;

  if (window.Shopify && window.Shopify.designMode) return; // don't log from the theme editor

  function safeSession(key, fallback) {
    try {
      var v = sessionStorage.getItem(key);
      if (!v) { v = fallback(); sessionStorage.setItem(key, v); }
      return v;
    } catch (e) { return fallback(); }
  }

  var sessionId = safeSession('fettle_calc_sid', function () {
    return Date.now().toString(36) + Math.random().toString(36).slice(2, 10);
  });

  function seen(sig) {
    try {
      var list = JSON.parse(sessionStorage.getItem('fettle_calc_seen') || '[]');
      if (list.indexOf(sig) !== -1) return true;
      list.push(sig);
      sessionStorage.setItem('fettle_calc_seen', JSON.stringify(list.slice(-50)));
    } catch (e) {}
    return false;
  }

  function device() {
    var w = window.innerWidth || 1024;
    return w < 750 ? 'mobile' : w < 990 ? 'tablet' : 'desktop';
  }

  function utm(name) {
    try { return new URLSearchParams(location.search).get(name) || null; } catch (e) { return null; }
  }

  function num(text) {
    if (!text) return null;
    var m = String(text).replace(',', '.').match(/-?\d+(\.\d+)?/);
    return m ? parseFloat(m[0]) : null;
  }

  function txt(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }

  function send(row) {
    try {
      fetch(ENDPOINT, {
        method: 'POST',
        keepalive: true,
        headers: {
          'Content-Type': 'application/json',
          apikey: KEY,
          Authorization: 'Bearer ' + KEY,
          Prefer: 'return=minimal'
        },
        body: JSON.stringify(row)
      }).catch(function () {});
    } catch (e) {}
  }

  function readState(calc) {
    var activeUnit = calc.querySelector('[data-sc-unit].is-active');
    var unit = activeUnit && activeUnit.getAttribute('data-sc-unit') === 'lb' ? 'lb' : 'kg';
    var inputs = calc.querySelectorAll('[data-sc-dog-input]');
    var cards = calc.querySelectorAll('[data-dog-card]');
    var dogs = [];
    var totalKg = 0;

    Array.prototype.forEach.call(inputs, function (row, i) {
      var nameEl = row.querySelector('[data-sc-name-input]');
      var wEl = row.querySelector('[data-sc-weight-input]');
      var errEl = row.querySelector('[data-sc-dog-error]');
      var w = wEl && wEl.value !== '' ? parseFloat(wEl.value) : null;
      var kg = w == null || isNaN(w) ? null : Math.round((unit === 'lb' ? w * LB_TO_KG : w) * 10) / 10;
      if (kg) totalKg += kg;
      var card = cards[i];
      dogs.push({
        name: nameEl ? nameEl.value.trim().slice(0, 40) || null : null,
        weight_entered: w,
        weight_kg: kg,
        out_of_range: !!(errEl && !errEl.hidden && txt(errEl)),
        error: errEl && !errEl.hidden ? txt(errEl).slice(0, 120) || null : null,
        daily_serving: card ? txt(card.querySelector('[data-dog-serving]')) || null : null,
        kcal_per_serving: card ? txt(card.querySelector('[data-dog-kcal]')) || null : null,
        pouch_lasts: card ? txt(card.querySelector('[data-dog-days]')) || null : null
      });
    });

    var summary = [];
    Array.prototype.forEach.call(calc.querySelectorAll('[data-sc-summary] .sc__stat'), function (s) {
      summary.push({ label: txt(s.querySelector('[data-label]')), value: txt(s.querySelector('[data-value]')) });
    });

    // "Pouch lasts" — prefer the combined summary figure, fall back to the first dog card
    var days = null;
    summary.forEach(function (s) { if (days == null && /last/i.test(s.label)) days = num(s.value); });
    if (days == null && dogs[0]) days = num(dogs[0].pouch_lasts);

    var banner = txt(calc.querySelector('[data-sc-banner]'));
    var pouchMatch = banner.match(/(\d+)\s*pouch/i);

    var results = calc.querySelector('[data-sc-results]');

    return {
      ready: !!(results && !results.hidden) && dogs.some(function (d) { return d.weight_kg; }),
      unit: unit,
      dogs: dogs,
      summary: summary,
      totalKg: Math.round(totalKg * 10) / 10,
      days: days,
      pouches: pouchMatch ? parseInt(pouchMatch[1], 10) : null,
      banner: banner.slice(0, 500) || null
    };
  }

  function baseRow(calc, state, event) {
    return {
      event: event,
      session_id: sessionId,
      product_id: calc.getAttribute('data-log-product-id'),
      product_handle: calc.getAttribute('data-log-product-handle'),
      product_title: calc.getAttribute('data-log-product-title'),
      dog_count: state.dogs.length,
      unit: state.unit,
      dogs: { dogs: state.dogs, summary: state.summary },
      total_weight_kg: state.totalKg || null,
      days_per_pouch: state.days,
      recommended_pouches: state.pouches,
      banner_text: state.banner,
      device: device(),
      page_path: location.pathname.slice(0, 300),
      utm_source: utm('utm_source'),
      utm_medium: utm('utm_medium'),
      utm_campaign: utm('utm_campaign')
    };
  }

  function signature(calc, state) {
    return [
      calc.getAttribute('data-log-product-id'),
      state.unit,
      state.dogs.map(function (d) { return d.weight_entered; }).join('|')
    ].join('#');
  }

  function watch(calc) {
    if (calc.__fettleLogging) return;
    calc.__fettleLogging = true;
    var timer = null;

    function schedule() {
      clearTimeout(timer);
      timer = setTimeout(function () {
        var state = readState(calc);
        if (!state.ready) return;
        if (seen(signature(calc, state))) return;
        send(baseRow(calc, state, 'calculated'));
      }, DEBOUNCE_MS);
    }

    calc.addEventListener('input', schedule);
    calc.addEventListener('change', schedule);
    calc.addEventListener('click', function (e) {
      if (e.target.closest('[data-sc-dog-increment],[data-sc-dog-decrement],[data-sc-unit]')) schedule();

      if (e.target.closest('[data-sc-add-to-cart]')) {
        clearTimeout(timer);
        // let the calculator fill in its quantity before reading it
        setTimeout(function () {
          var state = readState(calc);
          var row = baseRow(calc, state, 'added_to_cart');
          var q = calc.querySelector('[data-sc-cart-quantity-input]');
          var qty = q ? parseInt(q.value, 10) : NaN;
          row.quantity_added = isNaN(qty) ? null : Math.min(qty, 100);
          if (!seen(signature(calc, state))) send(baseRow(calc, state, 'calculated'));
          send(row);
        }, 50);
      }
    });
  }

  function init() {
    Array.prototype.forEach.call(document.querySelectorAll('serving-calculator'), watch);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  // quick-view / dynamically loaded calculators
  try {
    var pending = false;
    new MutationObserver(function () {
      if (pending) return;
      pending = true;
      setTimeout(function () { pending = false; init(); }, 500);
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
})();
